import { render } from "./Popper.vue?vue&type=template&id=580d9102&scoped=true"
import script from "./Popper.vue?vue&type=script&lang=js"
export * from "./Popper.vue?vue&type=script&lang=js"

import "./Popper.vue?vue&type=style&index=0&id=580d9102&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580d9102"]])

export default __exports__